module.exports = __webpack_public_path__ + "static/start-automatic-1b662427babfcb4d574f4a388832cb92.png";